import { Component, Inject, OnInit } from '@angular/core';
import { SBHttpServicesService } from '../shared/services/sbhttp-services.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-Error',
  templateUrl: './Error.component.html'
})
export class ErrorComponent implements OnInit {
  
  constructor(private httpService: SBHttpServicesService,  public translate: TranslateService) {
  }
  ngOnInit() {
   
  }
}
